import React from 'react';
import Row from "../../shared/components/Row";
import Card from "../../shared/components/Card";
import CardBody from "../../shared/components/CardBody";
import {I18nUtils} from "../../../i18n/I18nUtils";
// import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import * as profileActions from "../actions/profileActions";
import {connect} from "react-redux";
import * as sha256 from "sha256";

class ChangePasswordFormCard extends React.Component {

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      currentPassword: '',
      newPassword: '',
      newPasswordRepeat: '',
      btnSubmitEnabled: false,
    };
  }

  componentDidUpdate( prevProps, prevState ){
    if ( prevState.currentPassword !== this.state.currentPassword
      || prevState.newPassword !== this.state.newPassword
      || prevState.newPasswordRepeat !== this.state.newPasswordRepeat ){

      this.setState({
        btnSubmitEnabled: this.state.currentPassword && sha256(this.state.currentPassword) === this.props.user.password
        && this.state.newPassword && this.state.newPasswordRepeat && this.state.newPassword === this.state.newPasswordRepeat
      });
    }
  }

  onSubmit(event) {
    event.preventDefault();

    const user = this.props.user;
    user.password = sha256(this.state.newPassword);
    this.props.profileActions.updateProfile(user);
  }

  render() {
    return (
      <Row>
        <Card loading={this.props.loading}>
          <CardBody>
            <form onSubmit={this.onSubmit}>
              <div>
                {I18nUtils.tr('TR_ESCRIBE_TU_CONTRASENA_ANTIGUA_Y_LA_NUEVA')}
              </div>
              <hr/>
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="material-icons">lock</i>
                </span>
                <div className="form-line">
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    placeholder={I18nUtils.tr('TR_CONTRASENA_ANTIGUA')}
                    value={this.state.currentPassword}
                    onChange={(event) => {
                      this.setState({ currentPassword: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="material-icons">lock</i>
                </span>
                <div className="form-line">
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    placeholder={I18nUtils.tr('TR_CONTRASENA_NUEVA')}
                    value={this.state.newPassword}
                    onChange={(event) => {
                      this.setState({ newPassword: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="material-icons">lock</i>
                </span>
                <div className="form-line">
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    placeholder={I18nUtils.tr('TR_REPETIR_CONTRASENA_NUEVA')}
                    value={this.state.newPasswordRepeat}
                    onChange={(event) => {
                      this.setState({ newPasswordRepeat: event.target.value });
                    }}
                  />
                </div>
              </div>

              <button
                className="btn btn-block btn-lg bg-blue-grey waves-effect"
                type="submit"
                disabled={!this.state.btnSubmitEnabled}
              >{I18nUtils.tr('TR_CAMBIAR_CONTRASENA')}</button>

            </form>
          </CardBody>
        </Card>
      </Row>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.auth.user,
    loading: state.formProfile.loading,
  }
};

const mapDispatchToProps = dispatch => ({
  profileActions: bindActionCreators(profileActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordFormCard);

ChangePasswordFormCard.propTypes = {

};

ChangePasswordFormCard.defaultProps = {

};



// WEBPACK FOOTER //
// ./src/app/profile/components/ChangePasswordFormCard.js